import { graphql } from "@opensea/graphql"

export const TreasureRewardMediaFragment = graphql(`
  fragment TreasureRewardMedia on Badge {
    id
    name
    imageUrl
  }
`)
